import React, { Component } from "react";
import PropTypes from "prop-types";
import { Div, Button, H1, P } from "glamorous";
import Spinner from "../../common/Spinner";
import LittleSpinner from "../../common/LittleSpinner";
import styles from "../../../styles";
import data from "../../../data";
import { uploadToFilter, applyFilter } from "./actions";
import PreviewRead from "../Preview/Read";
import ScrollFixedContainer from "../../common/ScrollFixedContainer";
import { track } from '../../../misc/utils';

/**
 * https://una.im/CSSgram/
 */

const filters = [
  {
    name: "_1977",
    title: "1977",
  },
  {
    name: "earlybird",
    title: "Earlybird",
  },
  {
    name: "nashville",
    title: "Nashville",
  },
  {
    name: "toaster",
    title: "Toaster",
  },
  {
    name: "willow",
    title: "Willow"
  },
  {
    name: "lofi",
    title: "Lo-Fi"
  }
];

const setFiltered = (filter, src) => state => {
  state.filtered[filter] = src;
  return state;
};

const setCurrentFilter = (name, src) => state => {
  state.name = name;
  state.src = src;
  return state;
};

const setUploding = message => state => {
  state.uploading = message;
  return state;
};

class EditorFilter extends Component {
  constructor(props) {
    super();
    this.state = {
      uploading: true,
      filtered: {},
      name: props.label.filterName,
      src: props.label.background
    };
  }

  componentDidMount() {
    uploadToFilter(this.props.template.background).then(s3key => {
      this.setState(setUploding(false));
      this.applyFilters(s3key).catch(() => {
        this.applyFilters(s3key).catch(this.applyFilters(s3key));
      });
    });
  }

  applyFilters(s3key) {
    return Promise.all(
      this.getUnfiltered().map(filter => {
        return applyFilter(s3key, filter).then(src => {
          this.setState(setFiltered(filter, src));
        });
      })
    );
  }

  getUnfiltered() {
    const unfiltered = [];
    filters.forEach(filter => {
      if (!this.state.filtered[filter.name]) {
        unfiltered.push(filter.name);
      }
    });
    return unfiltered;
  }

  filterLabel() {
    // TODO: a bit weird, just copy label to state on init and do it there.
    let filteredLabel = this.props.label;
    filteredLabel.background = this.state.src;
    return filteredLabel;
  }

  render() {
    const { setArea } = this.props;
    return this.state.uploading ? (
      <Spinner />
    ) : (
      <Div className="container">
        <H1 css={styles.editor.title}>{data.copy("filterheading")}</H1>
          <Div css={styles.editor.columnWrapper}>
            <ScrollFixedContainer>
              <Div css={styles.editor.previewWrapper} position="relative">
                <PreviewRead label={this.filterLabel()} />
              </Div>
            </ScrollFixedContainer>
            <Div css={styles.editor.rightCol}>
              <Div css={styles.editor.boxShadow}>
                <P css={styles.editor.instructionalCopy}>{data.copy("filterSubhead")}</P>
                <Div css={styles.filter.filterOptions}>
                  {filters.map(f => this.renderThumb(f))}
                </Div>

                <Button
                  onClick={() => {
                    const { name } = this.state;
                    track.event('button', 'choose_filter', name);
                    this.props.useFilteredImage(this.state.filtered[name], name);
                    setArea("EditorSimple");
                  }}
                  css={styles.ctas.initial}
                  marginTop="15px"
                >
                  {data.copy("doneBtn")}
                </Button>
                <Button
                  onClick={() => {
                    track.event('button', 'click', 'reset_filters');
                    this.setState({
                      name: null,
                      src: this.props.template.background
                    });
                  }}
                  css={styles.ctas.outline}
                  marginTop="10px"
                >
                  {data.copy("filterResetBtn")}
                </Button>
              </Div>
            </Div>
        </Div>
      </Div>
    );
  }

  renderThumb = (filter) => {
    let name = filter.name;
    let title = filter.title;
    const src = this.state.filtered[name];

    return (
      <Div
        key={`filter_${name}`}
        css={styles.filter.previewThumb}
        onClick={() => {
          track.event('button', 'choose_filter', name);
          this.setState(setCurrentFilter(name, src));
        }}
      >
        {src ? (
          <Div>
            <Div css={styles.filter.thumbWrapper(this.state.name === name)}>
              <Div css={styles.filter.thumb(src)}></Div>
            </Div>
            <P css={styles.filter.filterName}>{title}</P>
          </Div>
        ) : (
          <LittleSpinner />
        )}
      </Div>
    );
  };
}

EditorFilter.propTypes = {
  images: PropTypes.object.isRequired,
  setArea: PropTypes.func.isRequired,
  setImage: PropTypes.func.isRequired,
  label: PropTypes.object.isRequired
};

export default EditorFilter;



// WEBPACK FOOTER //
// ./src/components/areas/EditorFilter/index.js